// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/produkte/roller-shutter-leather/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const produkteRollerShutterLeatherEN: PageEntry = {
  id: "example.produkte-rollofeder",
  locale: "en",
  slug: "produkte/roller-shutter-leather",
  seo: {
    title: "Roller Shutter Leather | Dietz GmbH",
    description: "Retaining spring for the axle of a parcel shelf roller blind in the trunk. Simple tool concept for small quantities and tight tolerances in the formed “bucket”.",
  },
  type: "post",
  h1: "Roller Shutter Leather",
  intro: "Retaining spring for the axle of a parcel shelf roller blind in the trunk. Simple tool concept for small quantities and tight tolerances in the formed “bucket”.",
  blocks: [
    { kind: "image", src: "/images/live/DTZ_rollofederjpg.jpg", alt: "Roller Shutter Leather", width: 800, height: 640 }
  ],
};
